import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, Badge, Form, ListGroup } from 'react-bootstrap';
import { useStoreState } from 'easy-peasy';

import HelperMetiers360 from '../../services/HelpersMetiers360';

import './PackageClientsComponent.scss';

// Above this number of clients, a filter input is displayed
const SEARCH_THRESHOLD = 10;

/**
 * PackageClientsComponent
 * collapsible, searchable and scrollable list of the clients associated to a package
 * @param {Array} clients array of { uniqueId, clientName }
 * @param {boolean} isDefault true for default packages, which are available to every client and can't be restricted
 */
const PackageClientsComponent = ({ clients: clientsProp, isDefault = false }) => {
    // The default parameter value doesn't cover an explicit null
    const clients = clientsProp ?? [];
    const clientsSlugs = useStoreState(state => state.actionSlugs.actionSlugsDispatcher('clients'));

    const [search, setSearch] = useState('');

    const sortedClients = useMemo(() =>
        [...(clientsProp ?? [])].sort((a, b) => HelperMetiers360.localeCompareWithNullable(a.clientName, b.clientName))
    , [clientsProp]);

    const filteredClients = sortedClients.filter(client => HelperMetiers360.isSearchInText(search, client.clientName));

    if (isDefault) {
        return <p className="text-muted mb-2"><i className="fas fa-users" /> Application par défaut : disponible pour tous les clients</p>;
    }

    if (!clients.length) {
        // Packages without clients are only available to premium (subscribed) clients
        return <p className="text-muted mb-2"><i className="fas fa-users" /> Application ouverte à tous les clients abonnés</p>;
    }

    return (
        <Accordion className="mb-3">
            <Accordion.Item eventKey="packageClients">
                <Accordion.Header>
                    Clients associés <Badge bg="primary" className="ms-2">{clients.length}</Badge>
                </Accordion.Header>
                <Accordion.Body>
                    {clients.length > SEARCH_THRESHOLD &&
                        <Form.Control
                            id="packageClientsSearch"
                            type="text"
                            className="mb-2"
                            placeholder="Filtrer les clients par nom"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    }
                    {filteredClients.length > 0
                        ? <ListGroup className="package-clients-list">
                            {filteredClients.map(client => clientsSlugs?.readOne
                                ? <ListGroup.Item key={client.uniqueId} action as={Link} to={clientsSlugs.readOne.replace(':uniqueId', client.uniqueId)}>
                                    {client.clientName}
                                </ListGroup.Item>
                                : <ListGroup.Item key={client.uniqueId}>{client.clientName}</ListGroup.Item>
                            )}
                        </ListGroup>
                        : <p className="text-muted mb-0">Aucun client ne correspond à votre recherche</p>
                    }
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

export default PackageClientsComponent;
